import { Suspense } from 'react';

import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { RouteErrorBoundary } from '@inbody/error';

import { pageRoute } from './RouterObject';

import { GenericLayoutV2 } from '@/shared/layout/v2';

const browserRouter = createBrowserRouter([
  {
    errorElement: <RouteErrorBoundary />,
    element: <GenericLayoutV2 />,
    children: pageRoute,
  },
]);

export const BrowserRouter = () => {
  return (
    <Suspense fallback={<div>Loading</div>}>
      <RouterProvider router={browserRouter} />
    </Suspense>
  );
};
